import { render, staticRenderFns } from "./CardStatistic.vue?vue&type=template&id=34456436&scoped=true&"
import script from "./CardStatistic.vue?vue&type=script&lang=js&"
export * from "./CardStatistic.vue?vue&type=script&lang=js&"
import style0 from "./CardStatistic.vue?vue&type=style&index=0&id=34456436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34456436",
  null
  
)

export default component.exports